import { userConstants, generalConstants } from '../constants';
import { userService } from '../services';
import { alertActions } from './';
import { history } from '../helpers';

export const userActions = {
  login,
  logout,
  register,
  getAll,
  delete: _delete,
  forgot,
  reset
};

function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      user => {
        dispatch(success(user));
        history.push(generalConstants.URL);
      },
      error => {
        // dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function register(user) {
  return dispatch => {
    dispatch(request(user));

    userService.register(user).then(
      user => {
        console.log(generalConstants.URL+"login");
        dispatch(success());
        history.push(generalConstants.URL+"login");
        dispatch(alertActions.success('Registration successful'));
      },
      error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(user) {
    return { type: userConstants.REGISTER_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.REGISTER_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.REGISTER_FAILURE, error };
  }
}

function getAll() {
  return dispatch => {
    dispatch(request());

    userService.getAll().then(users => dispatch(success(users)), error => dispatch(failure(error)));
  };

  function request() {
    return { type: userConstants.GETALL_REQUEST };
  }
  function success(users) {
    return { type: userConstants.GETALL_SUCCESS, users };
  }
  function failure(error) {
    return { type: userConstants.GETALL_FAILURE, error };
  }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    userService.delete(id).then(
      user => {
        dispatch(success(id));
      },
      error => {
        dispatch(failure(id, error));
      }
    );
  };

  function request(id) {
    return { type: userConstants.DELETE_REQUEST, id };
  }
  function success(id) {
    return { type: userConstants.DELETE_SUCCESS, id };
  }
  function failure(id, error) {
    return { type: userConstants.DELETE_FAILURE, id, error };
  }
}

//function send link forgot password
function forgot(username) {
  return dispatch => {
    dispatch(request(username));

    userService.forgot(username).then(
      user => {
        dispatch(success(username));
        dispatch(alertActions.success('Success, please check your email'));
      },
      error => {
        dispatch(failure(username, error));
      }
    );
  };

  function request(username) {
    return { type: userConstants.FORGOT_REQUEST };
  }
  function success(username) {
    return { type: userConstants.FORGOT_SUCCESS, username };
  }
  function failure(username, error) {
    return { type: userConstants.FORGOT_FAILURE, username, error };
  }
}

//function reset password
function reset(password, selector, token) {
  return dispatch => {
    dispatch(request(password));

    userService.reset(password, selector, token).then(
      user => {
        dispatch(success(password));
        dispatch(alertActions.success('Success, your password has been update please login'));
      },
      error => {
        dispatch(failure(password, error));
      }
    );
  };

  function request(password) {
    return { type: userConstants.RESET_REQUEST };
  }
  function success(password) {
    return { type: userConstants.RESET_SUCCESS, password };
  }
  function failure(password, error) {
    return { type: userConstants.RESET_FAILURE, password, error };
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js